import { formatDate } from "../utils/format-utils";

export default class SessionNote {
  sessionNoteId?: number;
  sessionId?: number | null;
  legacyActivityId?: number | null;
  clientId?: number | null;
  clientName?: string | null;
  dob?: Date | null;
  gender?: string | null;
  nyeisId?: string | null;
  providerName?: string | null;
  providerCredentials?: string | null;
  providerNPI?: string | null;
  dateOfService?: Date | null;
  startTime?: Date | null;
  endTime?: Date | null;
  serviceType?: string | null;
  serviceLocation?: string | null;
  intensity?: string | null;
  frequency?: number | null;
  authDurationMinutes?: number | null;
  isTelehealth?: boolean | null;
  sessionNoteFileId?: number | null;
  supervisorId?: number | null;
  supervisorSignatureId?: number | null;

  public constructor(params: SessionNote = {} as SessionNote) {
    let {
      sessionNoteId = 0,
      sessionId = null,
      legacyActivityId = null,
      clientId = null,
      clientName = null,
      dob = null,
      gender = null,
      nyeisId = null,
      providerName = null,
      providerCredentials = null,
      providerNPI = null,
      dateOfService = null,
      startTime = null,
      endTime = null,
      serviceType = null,
      serviceLocation = null,
      intensity = null,
      frequency = null,
      authDurationMinutes = null,
      isTelehealth = null,
      sessionNoteFileId = null,
      supervisorId = null,
      supervisorSignatureId = null,
    } = params;
    this.sessionNoteId = sessionNoteId;
    this.sessionId = sessionId;
    this.legacyActivityId = legacyActivityId;
    this.clientId = clientId;
    this.clientName = clientName;
    this.dob = dob;
    this.gender = gender;
    this.nyeisId = nyeisId;
    this.providerName = providerName;
    this.providerCredentials = providerCredentials;
    this.providerNPI = providerNPI;
    this.dateOfService = dateOfService;
    this.startTime = startTime;
    this.endTime = endTime;
    this.serviceType = serviceType;
    this.serviceLocation = serviceLocation;
    this.intensity = intensity;
    this.frequency = frequency;
    this.authDurationMinutes = authDurationMinutes;
    this.isTelehealth = isTelehealth;
    this.sessionNoteFileId = sessionNoteFileId;
    this.supervisorId = supervisorId;
    this.supervisorSignatureId = supervisorSignatureId;
  }

  get noteId() {
    return this.sessionNoteId;
  }

  get formattedClientDob() {
    return formatDate(this.dob);
  }

  get formattedDateOfService() {
    return formatDate(this.dateOfService);
  }

  get requiresSupervisorSignature() {
    return this.supervisorId != null;
  }
}
